import React from 'react';
import PropTypes from 'prop-types';

import FormSelect from '../../../../component-library/form-select';
import ButtonIcon from '../../../../component-library/button-icon';

const Sort = ({
	query,
	setQuery,
	pagination,
	setPagination,
	topMargin,
}) => {
	const sortFieldOptions = [
		{ id: 'name', text: 'Name', value: 'sortName' },
		{ id: 'dateUpdated', text: 'Updated Date', value: 'dateUpdated' },
	];

	const updateSortField = e => {
		const newSortField = e.target.value;
		setQuery({
			...query,
			sortField: newSortField,
			pageOffset: 0,
		});
		setPagination({
			...pagination,
			currentPage: 1,
		});
	};

	const updateSortOrder = sortOrder => {
		const newSortOrder = sortOrder;
		setQuery({
			...query,
			sortOrder: newSortOrder,
			pageOffset: 0,
		});
		setPagination({
			...pagination,
			currentPage: 1,
		});
	};

	return (
		<div className={`flex-row justify-flex-end ${topMargin ? 'margin-top-16' : ''}`}>
			<div className="margin-right-4">
				<FormSelect
					action={e => { updateSortField(e); }}
					data={sortFieldOptions}
					id="sort_field"
					name="sort_field"
					value={query.sortField}
				/>
			</div>
			<div className="margin-top-2">
				{query.sortOrder === 'asc' ? (
					<ButtonIcon
						icon="arrow-down-wide-short"
						title="Sort Descending"
						onClick={() => updateSortOrder('desc')}
					/>
				) : (
					<ButtonIcon
						icon="arrow-up-short-wide"
						title="Sort Ascending"
						onClick={() => updateSortOrder('asc')}
					/>
				)}
			</div>
		</div>
	);
};

export default Sort;

Sort.propTypes = {
	query: PropTypes.shape({
		searchString: PropTypes.string,
		sortField: PropTypes.string,
		sortOrder: PropTypes.string,
		pageSize: PropTypes.number,
	}).isRequired,
	setQuery: PropTypes.func.isRequired,
	pagination: PropTypes.shape({}).isRequired,
	setPagination: PropTypes.func.isRequired,
	topMargin: PropTypes.bool.isRequired,
};
